
/**
 * 工作流-结束节点
 * zxw
 * 创建时间 2026-04-03
 */

import CNF from '../../incs/Config';
import { winHeight } from '../../incs/FunHelper';
import { convertVariableTags, formattedContent } from '../../components/MultifunctionalInput';
import { useState, useEffect } from 'react';
import {
    ConfigProvider,
    Modal,
    Avatar,
    Space,
    Divider,
    Select,
    Button,
    Popover,
    Tag,
    Typography,
} from 'antd';
import {
    RightOutlined,
} from '@ant-design/icons';
import ContentEditable from "react-contenteditable";

const { Text } = Typography;

const EndNodeEntity = (props) => {
    const [open, setOpen] = useState(false);
    const [outputMode, setOutputMode] = useState('Text');

    const [outputVariable, setOutputVariable] = useState('');                       // 输出模版
    const [outputVariableIsFocused, setOutputVariableIsFocused] = useState(false);  // 系统提示词是否聚焦
    const [openOutputVariable, setOpenOutputVariable] = useState(false);            // 打开输出变量

    const cancel = () => {
        setOpen(false);
    }

    useEffect(() => {
        setOpen(props.open);
        // 初始化输出模式
        props.node.setData({
            ...props.node.data,
            output: {
                mode: outputMode,
            },
        });
        if (props.node.data?.output.result) {
            setOutputVariable(props.node.data?.output.result);    // 初始化输出模版
        }
    }, [props]);

    // 更新输出模版
    useEffect(() => {
        props.node.setData({
            ...props.node.data,
            output: {
                result: convertVariableTags(outputVariable),
            },
        });
    }, [outputVariable]);


    return (
        <ConfigProvider theme={{
            token: {
                colorPrimary: global.THEMECOLOR,
            },
        }}>
            <Modal
                title={
                    <Space>
                        <Avatar size='small' shape='square' icon={props.node.data?.icon} style={{ background: props.node.data?.theme, }} />
                        {props.node.data?.title}
                    </Space>
                }
                width={480}
                height={winHeight - CNF.menuHeight - CNF.basePadding * 2}
                style={{
                    top: CNF.menuHeight + CNF.basePadding,
                    right: 18,
                    position: 'absolute',
                }}
                mask={{
                    enabled: false,
                    closable: true,
                }}
                open={open}
                onCancel={cancel}
                footer={null}
            >
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <p>输出模式</p>
                <Select
                    placeholder='请选择模型'
                    style={{ width: '100%' }}
                    options={[
                        {
                            label: 'Text',
                            title: 'Text',
                        },
                        {
                            label: 'Json',
                            title: 'Json',
                        },
                    ]}
                    value={outputMode}
                    onChange={(value) => {
                        setOutputMode(value);
                        props.node.setData({
                            ...props.node.data,
                            output: {
                                mode: value,
                            },
                        });
                    }}
                />
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <p>输出模版</p>
                <div style={{
                    position: 'relative',
                    border: `1px solid ${outputVariableIsFocused ? props.colorPrimary : '#d9d9d9'}`,
                    padding: '10px 10px 2px 10px',
                    borderRadius: 6,
                    transition: 'all 0.2s',
                    boxShadow: `0 0 0 ${outputVariableIsFocused ? '1.5px' : '0'} ${props.colorPrimaryBg}`,
                }}>
                    <div
                        style={{
                            height: 100,
                            scrollbarColor: '#d9d9d9 transparent',
                            scrollbarWidth: 'thin',
                            overflowY: 'auto',
                        }}
                        onFocus={() => setOutputVariableIsFocused(true)}
                        onBlur={() => {
                            setOutputVariableIsFocused(false);
                        }}
                    >
                        <ContentEditable
                            html={formattedContent(outputVariable, props.graph)}                // 渲染带格式的 HTML
                            onChange={(e) => {
                                setOutputVariable(e.target.value ? e.target.value : '');
                            }}
                            tagName='div'
                            style={{ minHeight: '40px', outline: 'none' }}
                            onKeyDown={(e) => {
                                // 只处理单字符按键（key 长度为 1 且不是修饰键）
                                if (e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey) {
                                    // 注意：e.key 已经考虑了 Shift，例如 Shift+a 得到 'A'
                                    // 输入“/或者、”弹出变量选项界面
                                    if (e.key === '/' || e.key === '、') {
                                        e.preventDefault();
                                        setOpenOutputVariable(true);
                                    } else {
                                        setOpenOutputVariable(false);
                                    }
                                }
                            }}
                        />
                        <style>{`
                            .variable-tag {
                                background: #F5F6F8;
                                border-radius: 4px;
                                padding: 2px 6px;
                                margin: 0 4px;
                                color: ${props.colorTextBase};
                                user-select: all;
                                cursor: default;
                                font-size: ${CNF.fontSizeSM}px;
                            }
                            .variable-name {
                                color: ${props.colorPrimary};
                            }
                        `}</style>
                    </div>
                    <Text style={{ fontSize: CNF.fontSizeXS, color: CNF.basePlaceholderColor }}>输入“/”插入变量</Text>
                    {
                        openOutputVariable ? <div style={{
                            position: 'absolute',
                            top: 40,
                            left: 18,
                            width: 200,
                            padding: '6px 8px',
                            boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1)',
                            border: '1px solid #00000033',
                            borderRadius: 6,
                            background: '#fff',
                            fontSize: CNF.fontSizeSM,
                        }}>
                            <Space orientation='vertical' style={{ display: 'flex' }}>
                                {
                                    props.graph && props.graph.getNodes().map(node => {
                                        // 变量来自上游节点
                                        if (node.data?.key === 'End' || node.getZIndex() >= props.node.getZIndex()) return;
                                        return <Popover key={node.id}
                                            placement='leftTop'
                                            arrow={false}
                                            title={null}
                                            align={{
                                                offset: [-12, 0],
                                            }}
                                            styles={{
                                                container: {
                                                    padding: '4px 6px',
                                                },
                                            }}
                                            content={<Space orientation='vertical' style={{ display: 'flex' }}>
                                                {
                                                    node.data?.output && Object.keys(node.data?.output).map((item, index) => {
                                                        return <Button key={index} color='default' variant='text' style={{ width: '100%', justifyContent: 'left' }} onClick={() => {
                                                            const path = node.getZIndex().toString() + (node.data?.key === 'Start' ? '/input/sys/' : '/output/') + item;
                                                            setOutputVariable((outputVariable ? outputVariable : '') + CNF.APP_CONFIG_SPLIT + path + CNF.APP_CONFIG_SPLIT);
                                                            setOpenOutputVariable(false);
                                                        }}><Space><Text>{item}</Text><Tag>string</Tag></Space></Button>
                                                    })
                                                }
                                            </Space>}
                                        >
                                            <Space>
                                                <Avatar size={20} shape='square' icon={node.data.icon} style={{ background: node.data.theme, }} />
                                                <Text ellipsis style={{ width: 152 }}>{node.data.title}</Text>
                                                <RightOutlined />
                                            </Space>
                                        </Popover>
                                    })
                                }
                            </Space>
                        </div> : ''
                    }
                </div>
            </Modal>
        </ConfigProvider>
    );
}

export default EndNodeEntity;